// TextInput is Resuble component for Input fields
<template>
  <div>
    <label
      v-if="label"
      class="block text-sm font-medium text-gray-900"
      :for="id"
      >{{ label }} <span class="text-red-700" v-if="required">*</span></label
    >
    <div class="mt-1">
      <div class="relative">
        <input
          :id="id"
          ref="input"
          v-bind="sanitizedAttrs"
          class="mt-1 block w-full border rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
          :class="[
            {
              'border-red-400': errors.length,
              'pl-12': withIcon === true,
            },
            classes,
          ]"
          :aria-describedby="ariaDescribedBy"
          :type="type"
          :value="value"
          :placeholder="placeholder"
          @input="$emit('input', $event.target.value)"
          @keydown="$emit('keydown', $event)"
          @blur="$emit('blur', $event)"
          @keyup="$emit('keyup', $event)"
        />
        <i
          @click="$emit('showHide')"
          @keydown.enter.prevent="$emit('showHide')"
          @keydown.space.prevent="$emit('showHide')"
          v-if="type == 'password' && showIcon"
          class="fa fa-eye absolute right-0 pr-3 top-1/2 -translate-y-1/2 text-sm leading-5"
          role="button"
          tabindex="0"
          aria-label="Show password"
        ></i>
        <i
          @click="$emit('showHide')"
          @keydown.enter.prevent="$emit('showHide')"
          @keydown.space.prevent="$emit('showHide')"
          v-if="type == 'text' && showIcon1"
          class="fa fa-eye-slash absolute right-0 pr-3 top-1/2 -translate-y-1/2 text-sm leading-5"
          role="button"
          tabindex="0"
          aria-label="Hide password"
        ></i>
        <div
          class="absolute left-0 top-0 bottom-0 w-10 block ml-2"
          v-if="withIcon"
        >
          <slot name="icon"></slot>
        </div>
      </div>
      <div
        v-if="errors.length"
        class="text-red-600 mt-1 text-sm"
        :id="`${id}-error`"
        role="status"
        aria-live="polite"
        aria-atomic="true"
      >
        {{ errors[0] }}
      </div>
    </div>
    <p
      v-if="helptext"
      class="mt-0 text-xs text-gray-500"
      :id="`${id}-help`"
    >
      {{ helptext }}
    </p>
  </div>
</template>

<script>
export default {
  name: "TextInput",

  inheritAttrs: false,

  props: {
    id: {
      type: String,
      default: "text",
    },
    type: {
      type: String,
      default: "text",
    },
    value: String,
    label: String,
    placeholder: String,
    helptext: String,
    errors: {
      type: Array,
      default: () => [],
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    showIcon1: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },

  computed: {
    classes() {
      return {
        "border-2 border-barley": this.bordered === true,
        "border bg-gray-200 focus:bg-white": this.bordered === false,
      };
    },
    sanitizedAttrs() {
      const attrs = { ...this.$attrs };
      const role = typeof attrs.role === "string" ? attrs.role.trim().toLowerCase() : "";

      // Prevent invalid ARIA combinations like role="presentation/none" on form controls.
      if (role === "presentation" || role === "none") {
        delete attrs.role;
      }

      return attrs;
    },
    ariaDescribedBy() {
      const ids = [];
      if (this.helptext) ids.push(`${this.id}-help`);
      if (this.errors.length) ids.push(`${this.id}-error`);
      return ids.length ? ids.join(" ") : null;
    },
  },
};
</script>
